import React from "react";
import { createRoot } from "react-dom/client";
import Kabuk from "./Kabuk.jsx";

createRoot(document.getElementById("kok")).render(
  <React.StrictMode>
    <Kabuk />
  </React.StrictMode>
);
